import React from 'react';
import { Card } from '../ui/card';

const PrivacyPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto py-16 px-4">
      <Card className="p-8 bg-black/40 border-white/10">
        <h1 className="heading-1 mb-8 text-white">Privacy Policy</h1>
        <div className="space-y-6 text-gray-300 body-medium">
          
          <section>
            <h2 className="heading-2 mb-4 text-white">1. Introduction</h2>
            <p>
              Godquantum Systems Tech Research Labs India Pvt Ltd ("Godquantum Systems," "we," "us," or "our") 
              is committed to protecting your privacy. This Privacy Policy explains how we collect, use, 
              disclose, and safeguard your information when you visit our website at godquantum.tech 
              ("Website") or use our services.
            </p>
            <p className="mt-4">
              This policy applies to information collected through our Website, email communications, 
              and other electronic communications between you and Godquantum Systems.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">2. Information We Collect</h2>
            <h3 className="heading-3 mb-2 text-emerald-300">Personal Information</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>Name, email address, phone number</li>
              <li>Company or institution affiliation</li>
              <li>Professional title and work information</li>
              <li>Country of residence</li>
              <li>Communication preferences</li>
            </ul>
            
            <h3 className="heading-3 mb-2 text-emerald-300 mt-4">Automatically Collected Information</h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>IP address and device identifiers</li>
              <li>Browser type and operating system</li>
              <li>Website usage patterns and analytics</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">3. How We Use Your Information</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>To provide and maintain our services</li>
              <li>To communicate with you about our products and services</li>
              <li>To process your inquiries and demo requests</li>
              <li>To send newsletters and marketing communications (with consent)</li>
              <li>To improve our website and services</li>
              <li>To comply with legal obligations</li>
              <li>To prevent fraud and enhance security</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">4. Information Sharing</h2>
            <p>We do not sell, trade, or otherwise transfer your personal information to third parties except:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>With your explicit consent</li>
              <li>To our trusted service providers who assist in website operation</li>
              <li>When required by law or legal process</li>
              <li>To protect our rights, privacy, safety, or property</li>
              <li>In connection with business transfers or mergers</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your 
              personal information against unauthorized access, alteration, disclosure, or destruction. 
              However, no electronic transmission or storage method is 100% secure.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">6. Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Access your personal information</li>
              <li>Correct inaccurate or incomplete data</li>
              <li>Request deletion of your personal information</li>
              <li>Object to processing of your personal information</li>
              <li>Withdraw consent for marketing communications</li>
              <li>Request data portability</li>
            </ul>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">7. Cookies and Tracking</h2>
            <p>
              Our Website uses cookies and similar technologies to enhance user experience, 
              analyze website traffic, and serve personalized content. You can control cookie 
              preferences through your browser settings.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">8. Data Retention</h2>
            <p>
              We retain personal information only as long as necessary to fulfill the purposes 
              outlined in this policy, comply with legal obligations, or resolve disputes.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">9. International Data Transfers</h2>
            <p>
              Your information may be processed in countries other than your country of residence. 
              We ensure appropriate safeguards are in place for international data transfers.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">10. Children's Privacy</h2>
            <p>
              Our services are not directed to individuals under 18 years of age. We do not 
              knowingly collect personal information from children under 18.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">11. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy periodically. We will notify you of significant 
              changes by posting the new policy on our Website with an updated effective date.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">12. Jurisdiction and Governing Law</h2>
            <p>
              This Privacy Policy is governed by the laws of India. Any disputes arising from 
              this policy shall be subject to the exclusive jurisdiction of the courts in 
              New Delhi, India, or the local geography where business is conducted.
            </p>
          </section>

          <section>
            <h2 className="heading-2 mb-4 text-white">13. Contact Information</h2>
            <p>
              For questions about this Privacy Policy or to exercise your rights, please contact us at:
            </p>
            <div className="mt-4 p-4 bg-white/5 rounded-lg border border-emerald-500/20">
              <p><strong>Email:</strong> contact@godquantum.tech</p>
              <p><strong>Address:</strong> Godquantum Systems Tech Research Labs India Pvt Ltd</p>
              <p className="text-sm text-gray-400 mt-2">
                Bengaluru, Karnataka, India
              </p>
            </div>
          </section>

          <div className="mt-8 pt-8 border-t border-white/20 text-sm text-gray-400">
            <p><strong>Last Updated:</strong> January 2025</p>
            <p><strong>Effective Date:</strong> January 2025</p>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PrivacyPolicy;